import { Reveal } from "./Reveal";
import { PhoneCall, SlidersHorizontal, ShieldCheck } from "lucide-react";

const STEPS = [
  {
    icon: PhoneCall,
    num: "01",
    title: "Reach out",
    desc: "Call or send the quick form. Tell me a little about your household, doctors, and budget. No paperwork required.",
  },
  {
    icon: SlidersHorizontal,
    num: "02",
    title: "I compare your options",
    desc: "I review every plan you qualify for across carriers, find every subsidy, and bring you a clear comparison in plain English.",
  },
  {
    icon: ShieldCheck,
    num: "03",
    title: "Enroll with confidence",
    desc: "You choose on your own timeline. I handle the enrollment and stay your point of contact all year long.",
  },
];

export default function Process() {
  return (
    <section className="py-24 md:py-32" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="text-sm uppercase tracking-[0.25em] font-bold text-[#C85A40] mb-4">Simple from the start</p>
          <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-tight text-[#1A1714] max-w-2xl mb-16">
            Getting covered, in three easy steps
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.1}>
              <div
                data-testid={`process-step-${s.num}`}
                className="group relative h-full bg-white rounded-2xl border border-[#D8D0C5] p-8 hover:border-[#C85A40] transition-colors duration-300"
              >
                <span className="absolute top-6 right-8 font-display text-6xl text-[#EAE3D9] group-hover:text-[#E8A365] transition-colors duration-300">
                  {s.num}
                </span>
                <div className="w-12 h-12 rounded-full bg-[#1E3A2F] flex items-center justify-center">
                  <s.icon className="w-5 h-5 text-[#E8A365]" />
                </div>
                <h3 className="mt-6 font-display text-2xl tracking-tight text-[#1A1714]">{s.title}</h3>
                <p className="mt-3 text-[#4A453F] leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
